/**
 * Estado de la suscripción de la empresa con Nubempresa (plan:
 * backend/app/Domains/Billing/CONTRATOS.md, fase 4).
 *
 * Hasta el 22 sep 2026 el POS sólo se enteraba de la deuda **al intentar cerrar una venta**: el
 * servidor respondía `BLOCK_ACTION_PAYMMENT` y `http.js` abría el aviso. Eso llega tarde —el
 * pedido ya se guardó en la base local del POS— y con el POS sin conexión no llega nunca. Ahora
 * también se consulta al entrar y al abrir turno, que es cuando el cajero todavía puede avisar.
 *
 * Es sólo un aviso: quien bloquea es el servidor.
 */
export async function revisarEstadoDeCuenta(http, store) {
  try {
    const res = await http.get('api/v1/subscription/get-info-pending-payments', null, false, false, false); // sin loading ni mensajes de error
    // Una empresa sin contrato responde `success: false` («No existe un contrato»): eso es estar al día.
    if (!res || !res.success || !res.item) {
      return null;
    }
    const estado = res.item.estado_de_cuenta;
    // Servidor viejo (sin la fase 2): se cae al dato de siempre, el saldo pendiente.
    const debe = estado ? estado.estado !== 'al_dia' : Number(res.item.total_balance) > 0;
    if (debe) {
      store.commit('setPaymentAnnouncement', true);
    }
    return estado || null;
  } catch (e) {
    // Sin conexión o con el servidor caído no se avisa nada: el POS tiene que poder vender.
    console.log('estado de cuenta: no se pudo consultar', e);
    return null;
  }
}
